import { createContext, useContext, type ReactNode } from "react";

const AppContext = createContext<null>(null);

export function AppProvider({ children }: { children: ReactNode }) {
  return <AppContext.Provider value={null}>{children}</AppContext.Provider>;
}

export function useAppContext(): null {
  return useContext(AppContext);
}
